<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="pgTitle" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingData"/>

            <!-- Form -->
            <div v-else class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.title" :b-invalid="false" :b-success="false">
                        <label for="title">Título</label>
                        <input v-model="dataRegister.title" @blur="$v.dataRegister.title.$touch()" type="text"
                               class="form-control" id="title" name="title">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.fromWhoEmail" :b-invalid="false" :b-success="false">
                        <div class="form-group">
                          <label>De quem será enviado o email?</label>
                          <select v-model="dataRegister.fromWhoEmail" id="fromWhoEmail" name="fromWhoEmail" required>
                            <option value="">Selecione</option>
                            <option value="marco@marqponto.com.br">marco@marqponto.com.br</option>
                            <option value="thiago@marqponto.com.br">thiago@marqponto.com.br</option>
                            <option value="mauricio@marqponto.com.br">mauricio@marqponto.com.br</option>
                            <option value="marketing@marqponto.com.br">marketing@marqponto.com.br</option>
                            <option value="suporte@marqponto.com.br">suporte@marqponto.com.br</option>
                          </select>
                        </div>
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.plan" :b-invalid="false" :b-success="false">
                        <div class="form-group">
                          <label>Plano</label>
                          <select v-model="dataRegister.plan" id="plan" name="plan" required>
                            <option value="">Selecione</option>
                            <option value="9">Todos</option>
                            <option value="1">Free</option>
                            <option value="0">Cliente em Teste</option>
                            <option value="2">Cliente até 10</option>
                            <option value="3">Cliente acima 10</option>
                          </select>
                        </div>
                      </valid-field>
                    </div>
                  </div>

                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.companyDaysCreated" :b-invalid="false" :b-success="false">
                        <label for="title">Quantidade de dias cadastrado</label>
                        <input v-model="dataRegister.companyDaysCreated"
                               @blur="$v.dataRegister.companyDaysCreated.$touch()" v-mask="'####'" type="text"
                               class="form-control" id="companyDaysCreated" name="companyDaysCreated">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.minEmployee" :b-invalid="false" :b-success="false">
                        <label for="title">Mínimo de funcionário</label>
                        <input v-model="dataRegister.minEmployee" @blur="$v.dataRegister.minEmployee.$touch()"
                               v-mask="'#####'" type="text" class="form-control" id="minEmployee" name="minEmployee">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataRegister.maxEmployee" :b-invalid="false" :b-success="false">
                        <label for="title">Máximo de funcionário</label>
                        <input v-model="dataRegister.maxEmployee" @blur="$v.dataRegister.maxEmployee.$touch()"
                               v-mask="'#####'" type="text" class="form-control" id="maxEmployee" name="maxEmployee">
                      </valid-field>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <valid-field :v="$v.dataRegister.htmlContent" :b-invalid="false" :b-success="false">
                      <label>Conteúdo</label>
                      <vue-editor id="htmlContent" name="htmlContent" useCustomImageHandler
                                  v-model="dataRegister.htmlContent" @imageAdded="handleImageAdded"
                                  aria-required="true"/>
                      <span>&#123;empresa&#125; - ao inserir essa tag será modificado pelo nome da empresa.</span>
                      <div v-if="loadingEditor" class="loading-content">
                        <div class="loading-editor">
                        <span>
                          <i class="fa fa-spinner spinning"></i>
                        </span>
                        </div>
                        <p>Aguarde o envio da imagem...</p>
                      </div>
                    </valid-field>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Ativo?</label>
                        <select v-model="dataRegister.isActive" id="isActive" name="isActive">
                          <option value="true">Sim</option>
                          <option value="false">Não</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label for="title">E-mail de Teste <span>(preencher apenas se for teste)</span></label>
                      <input v-model="dataRegister.emailTest" type="text" class="form-control" id="emailTest"
                             name="emailTest">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                  <button v-on:click="checkSend(false)" class="ax-wid">
                    <span v-if="!loadingSend">Salvar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                  <button v-on:click="checkSend(true)" class="ax-wid warning">
                    <span v-if="!loadingSend">Enviar e-mail de teste</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import validField from "../../components/default/validField.vue";
import {
  VueEditor,
  Quill
} from "vue2-editor";

import {
  CREATE_FUP,
  CHANGE_FUP,
  GET_FUP,
  UPLOAD_IMG_BLOG_PROD
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import {
  required
} from "vuelidate/lib/validators";

import swal from "sweetalert";

export default {
  name: "register-follow-up",
  components: {
    topMenu,
    validField,
    pageHeader,
    fullLoading,
    VueEditor,
    Quill
  },
  data() {
    return {
      failRequest: false,
      loadingData: false,
      loadingEditor: false,
      loadingSend: false,
      pgTitle: '',
      dataRegister: {
        title: '',
        htmlContent: '',
        fromWhoEmail: '',
        plan: '',
        companyDaysCreated: '',
        minEmployee: '',
        maxEmployee: '',
        emailTest: '',
        isActive: ''
      }
    }
  },
  methods: {
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      UTIL_SERVICE.console("FILE SEND: ", file);

      this.loadingEditor = true;
      REQUEST_SERVICE.fileUpload(UPLOAD_IMG_BLOG_PROD, file).then((response) => {
        UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

        let url = response.data;
        Editor.insertEmbed(cursorLocation, 'image', url);
        resetUploader();

        $('img').each(function () {
          $(this).attr("alt", "img-marqponto");
        });

        this.loadingEditor = false;
      }).catch((reason) => {
        this.loadingEditor = false;
        UTIL_SERVICE.console("Error Upload img: ", reason);
      });
    },
    getFup() {
      this.loadingData = true;
      this.failRequest = false;

      let url = GET_FUP + "?id=" + this.$route.params.idFup;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_FUP:", response.data);

        this.dataRegister = response.data;
        this.dataRegister.isActive = this.dataRegister.isActive.toString();
        this.loadingData = false;
      }).catch((reason) => {
        this.loadingData = false;
        this.failRequest = true;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    createFup() {
      this.loadingSend = true;
      this.failRequest = false;

      UTIL_SERVICE.console("Data send:", this.dataRegister);
      REQUEST_SERVICE.post(CREATE_FUP, this.dataRegister).then((response) => {
        UTIL_SERVICE.console("RESULT CREATE_FUP:", response.data);

        this.loadingSend = false;

        swal("Aviso", "FollowUp criado com sucesso.", "success");

        // Redirect user.
        if (!this.dataRegister.isTest)
          this.$router.push({
            path: '/followup'
          });
      }).catch((reason) => {
        this.loadingSend = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    updateFlup() {
      this.loadingSend = true;
      this.failRequest = false;

      UTIL_SERVICE.console("Data send:", this.dataRegister);
      REQUEST_SERVICE.put(CHANGE_FUP, this.dataRegister).then((response) => {
        UTIL_SERVICE.console("RESULT CHANGE_FUP:", response.data);

        this.loadingSend = false;

        swal("Aviso", "FollowUp alterado com sucesso.", "success");

        // Redirect user.
        if (!this.dataRegister.isTest)
          this.$router.push({
            path: '/followup'
          });
      }).catch((reason) => {
        this.loadingSend = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    checkSend(value) {
      if (!this.$v.$invalid) {
        this.dataRegister.isTest = value;

        if (!value)
          this.dataRegister.emailTest = '';

        if (this.$route.params.idFup) {
          this.updateFlup();
        } else {
          this.createFup();
        }
      } else {
        this.$v.$touch();
      }
    }
  },
  beforeMount() {
    if (this.$route.params.idFup) {
      this.pgTitle = "Editar FollowUp";

      this.getFup();
    } else {
      this.pgTitle = "Cadastro de FollowUp";

      this.dataRegister.isActive = "true";
    }
  },
  validations: {
    dataRegister: {
      title: {
        required
      },
      companyDaysCreated: {
        required
      },
      htmlContent: {
        required,
      },
      fromWhoEmail: {
        required,
      },
      plan: {
        required,
      },
      minEmployee: {
        required,
      },
      maxEmployee: {
        required,
      }
    },
  },
}
</script>

<style lang="scss">
label {
  span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/RegisterFollowUp.vue